import { FlightState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import FlightInfo from "./interfaces/flightInfo";
import Flights from './interfaces/flights'
import SelectedFlight from "./interfaces/selectedFlight";

export default {
    isSelectedFlight: (state: FlightState) => (flightType: string, flightId: string): boolean => {
        return flightType === state.selectedFlight.type && flightId === state.selectedFlight.id
    },
    isFlightDataValid: () => (flights: FlightInfo): boolean => {
        return flights !== undefined && flights.outbound.length > 1 && flights.outbound[0].name !== '';
    },
    hasFlightInfos: () => (flights: FlightInfo): boolean => {
        return flights.outbound.length > 2 && flights.return.length > 2 ;
    },
    hasNote: () => (flight: Flights): boolean => {
        return flight.note !== '';
    },
    getSelectedFlight(state: FlightState): SelectedFlight {
        return state.selectedFlight;
    },
    funnelFlights: (state: FlightState): Flights[] => {
        // create deep copy of availableFlights to maintain the integrity of the state when modifying flights.
        const flights = JSON.parse(JSON.stringify(state.availableFlights));

        flights.forEach((flight: Flights) => {
            delete flight.title;
            delete flight.note;
            delete flight.airlineLogoUrl
        });

        return flights;
    }
} as GetterTree<FlightState, IStore>
